import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "@/components/feature/ArticleLayout";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
const articlePath = "/artykul/dla-poczatkujacych";
const articleTitle = "USFansSpreadsheet dla początkujących – kompletny start";
const articleDesc = "Rozpocznij przygodę z USFansSpreadsheet. Przewodnik dla początkujących obejmujący pierwsze kroki, podstawowe pojęcia i drogę do zaawansowanego użytkowania.";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": articleTitle,
  "description": articleDesc,
  "author": { "@type": "Person", "name": "Anna Kowalska", "jobTitle": "Specjalista SEO" },
  "datePublished": "2026-06-07",
  "dateModified": "2026-06-24",
  "publisher": { "@type": "Organization", "name": "USFansSpreadsheet.help", "url": siteUrl },
  "mainEntityOfPage": { "@type": "WebPage", "@id": `${siteUrl}${articlePath}` },
  "inLanguage": "pl-PL"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Strona główna", "item": siteUrl },
    { "@type": "ListItem", "position": 2, "name": "Artykuły", "item": `${siteUrl}/artykul/przewodnik-usfansspreadsheet` },
    { "@type": "ListItem", "position": 3, "name": "Dla początkujących" }
  ]
};

const relatedArticles = [
  { title: "Kompletny przewodnik po USFansSpreadsheet", to: "/artykul/przewodnik-usfansspreadsheet" },
  { title: "Jak korzystać z USFansSpreadsheet", to: "/artykul/jak-korzystac-usfansspreadsheet" },
  { title: "10 praktycznych wskazówek", to: "/artykul/wskazowki-usfansspreadsheet" },
];

export default function ArticleBeginners() {
  return (
    <>
      <PageMeta
        title={articleTitle}
        description={articleDesc}
        keywords="USFansSpreadsheet, dla początkujących, pierwsze kroki, poradnik, start, nauka, podstawy, Polska"
        canonicalPath={articlePath}
        ogType="article"
      />
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />

      <Navbar />
      <ArticleLayout title="USFansSpreadsheet dla początkujących – kompletny start" category="Dla początkujących" heroImg="https://readdy.ai/api/search-image?query=Beginner%20friendly%20clean%20desk%20workspace%20with%20open%20laptop%20showing%20simple%20spreadsheet%20interface%2C%20a%20cup%20of%20tea%20and%20a%20small%20plant%2C%20warm%20cream%20wall%20background%2C%20soft%20morning%20light%2C%20welcoming%20and%20calm%20learning%20atmosphere%2C%20approachable%20photography%20style&width=1400&height=600&seq=art-begin-hero-v2&orientation=landscape" heroImgAlt="USFansSpreadsheet dla początkujących" relatedArticles={relatedArticles}>
        <p className="text-lg md:text-xl text-foreground-800 font-medium leading-relaxed">Rozpoczynasz swoją przygodę z <strong>USFansSpreadsheet</strong>? Ten przewodnik został stworzony specjalnie dla początkujących użytkowników, którzy chcą szybko opanować podstawy i zacząć efektywnie korzystać z platformy.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Pierwsze kroki z USFansSpreadsheet</h2>
        <p><strong>USFansSpreadsheet</strong> został zaprojektowany z myślą o intuicyjnej obsłudze. Po utworzeniu konta zostaniesz powitany przez przejrzysty panel główny, który poprowadzi Cię przez najważniejsze funkcje. Nie potrzebujesz żadnego doświadczenia technicznego, aby zacząć.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Podstawowe pojęcia</h2>
        <p>W <strong>USFansSpreadsheet</strong> najważniejszymi elementami są arkusze, komórki i formuły. Arkusz to dokument zawierający dane, komórka to pojedyncze pole, a formuła to wyrażenie wykonujące obliczenia. Opanowanie tych trzech elementów to klucz do sukcesu.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Twoja droga do zaawansowanego użytkownika</h2>
        <p>Gdy opanujesz podstawy, <strong>USFansSpreadsheet</strong> oferuje ścieżkę rozwoju poprzez coraz bardziej zaawansowane funkcje. Od prostych arkuszy, przez wykresy, aż po zaawansowaną analizę danych — platforma rośnie razem z Tobą.</p>
      </ArticleLayout>
      <Footer />
    </>
  );
}